<ul class="list-unstyled mb-0" #scrollableDiv id="searchbar-groups">
  <li>
    <span (click)="resetProductGroups()">{{ "ALL_GROUPS" | translate }}</span>
  </li>
  @for (group of groups; track group; let i = $index) {
    <li class="treeItem" [id]="'sb-group-pg-' + group.name">
      <span (click)="selectProductGroup(group, true)"
        >{{ group.description }}
        @if (group.doc_count) {
          ({{ group.doc_count }})
          }</span
          >
          <ul class="list-unstyled ps-1">
            @for (article_group of group.sub_items; track article_group; let i = $index) {
              <li
                class="treeItem"
                [id]="'sb-group-ag-' + article_group.name"
        [ngStyle]="{
          'font-size': group.sub_items.length > 5 ? '90%' : ''
        }"
                >
                <span
          (click)="
            selectProductGroup(group); selectArticleGroup(article_group, true)
          "
                  >{{ article_group.description }}
                  @if (article_group.doc_count) {
                    ({{ article_group.doc_count }})
                    }</span
                    >
                    <ul class="list-unstyled ps-1">
                      @for (
                        article_sub_group of article_group.sub_items; track
                        article_sub_group; let i = $index) {
                        <li
                          class="treeItem"
                          [id]="'sb-group-sg-' + article_sub_group.name"
                          >
                          <span
              (click)="
                selectProductGroup(group);
                selectArticleGroup(article_group);
                selectArticleSubGroup(article_sub_group, true)
              "
                            >{{ article_sub_group.description }}
                            @if (article_sub_group.doc_count) {
                              ({{ article_sub_group.doc_count }})
                              }</span
                              >
                              <ul class="list-unstyled ps-1">
                                @for (
                                  article_variation_group of article_sub_group.sub_items; track
                                  article_variation_group; let i = $index) {
                                  <li
                                    class="treeItem"
                                    [id]="'sb-group-vg-' + article_variation_group.name"
                                    >
                                    <span
                  (click)="
                    selectProductGroup(group);
                    selectArticleGroup(article_group);
                    selectArticleSubGroup(article_sub_group);
                    selectArticleVariationGroup(article_variation_group, true)
                  "
                                      >{{ article_variation_group.description }} ({{
                                      article_variation_group.doc_count
                                      }})</span
                                      >
                                    </li>
                                  }
                                </ul>
                              </li>
                            }
                          </ul>
                        </li>
                      }
                    </ul>
                  </li>
                }
              </ul>
